import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { finalize, of } from 'rxjs';
import type { ResRiepilogoDettaglioNuovoInvioI } from '../models/interfaces/documenti-adempimenti/riepilogo-dettaglio-richiesta-nuovo-invio.interface';
import { RichiesteNuovoInvioService } from '../services/richieste-nuovo-invio.service';
import { SpinnerService } from '../services/spinner-service';

/**
 * Carica il riepilogo della richiesta prima del mount della pagina carica documento,
 * per precompilare Adempimento normativo, Fase, Esercizio e Tipo documento.
 */
export const caricaDocumentoRichiestaNuovoInvioResolver: ResolveFn<
  ResRiepilogoDettaglioNuovoInvioI | null
> = (route) => {
  const richiesteService = inject(RichiesteNuovoInvioService);
  const spinnerService = inject(SpinnerService);
  const sequRichiesta = Number(route.paramMap.get('sequRichiesta'));

  if (!Number.isFinite(sequRichiesta) || sequRichiesta <= 0) {
    return of(null);
  }

  spinnerService.enableSpinner();
  return richiesteService.getRiepilogoDettaglio(sequRichiesta).pipe(
    finalize(() => spinnerService.disableSpinner()),
  );
};
